import { newSave, type SaveData } from './progress';

/**
 * Stores the save game in this browser (localStorage). If storage is not
 * available (private mode), the game still works for the session.
 * Phase 7: the store app keeps the same format.
 */
const KEY = 'cafe-paws.save';
let memory: SaveData | null = null;

export function loadSave(): SaveData {
  if (memory) return memory;
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      const data = JSON.parse(raw) as SaveData;
      if (data.version === 1) return (memory = { ...newSave(), ...data });
    }
  } catch {
    /* fall through to a new game */
  }
  return (memory = newSave());
}

export function storeSave(s: SaveData): void {
  memory = s;
  try {
    localStorage.setItem(KEY, JSON.stringify(s));
  } catch {
    /* not persisted */
  }
}

export function resetSave(): void {
  memory = null;
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
